import { TreeRuleEditContext } from "../TreeRuleEditContext";
import { TreeRuleConfiguration } from "../TreeRuleConfiguration";
import { TestResultDataType } from "../../../Common/Testing/TestResultDataType";
import { BaseTestResultData } from "../../../Common/Testing/BaseTestResultData";

export class TreeRuleTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.TREE_RULE;
    editContext?: TreeRuleEditContext;

    private _definition?: TreeRuleConfiguration;

    get definition(): TreeRuleConfiguration | undefined {
        return this._definition;
    }

    set definition(definition: TreeRuleConfiguration | undefined) {
        this._definition = definition;

        if (this._definition) {
            this.editContext = new TreeRuleEditContext(this._definition);
        }
    }
}
